__turbopack_context__.v({
  "Feature": "optional-test-series-module__zzTaiW__Feature",
  "acheiverrank": "optional-test-series-module__zzTaiW__acheiverrank",
  "contactheader": "optional-test-series-module__zzTaiW__contactheader",
  "dayValue": "optional-test-series-module__zzTaiW__dayValue",
  "facultyborder1": "optional-test-series-module__zzTaiW__facultyborder1",
  "invalidCheck2": "optional-test-series-module__zzTaiW__invalidCheck2",
  "mbtableheading": "optional-test-series-module__zzTaiW__mbtableheading",
  "normalbutton": "optional-test-series-module__zzTaiW__normalbutton",
  "pagemaintitle": "optional-test-series-module__zzTaiW__pagemaintitle",
  "paybill": "optional-test-series-module__zzTaiW__paybill",
  "phoneiconcss": "optional-test-series-module__zzTaiW__phoneiconcss",
  "redunderline": "optional-test-series-module__zzTaiW__redunderline",
  "sectionredtitle": "optional-test-series-module__zzTaiW__sectionredtitle",
  "sectiontitle": "optional-test-series-module__zzTaiW__sectiontitle",
  "sectiontitle2": "optional-test-series-module__zzTaiW__sectiontitle2",
  "sectiontitlesub": "optional-test-series-module__zzTaiW__sectiontitlesub",
  "startDate": "optional-test-series-module__zzTaiW__startDate",
  "table": "optional-test-series-module__zzTaiW__table",
  "table1": "optional-test-series-module__zzTaiW__table1",
  "tableheading": "optional-test-series-module__zzTaiW__tableheading",
  "tablepara": "optional-test-series-module__zzTaiW__tablepara",
  "tablepara1": "optional-test-series-module__zzTaiW__tablepara1",
  "tablescroll": "optional-test-series-module__zzTaiW__tablescroll",
  "tabletitle": "optional-test-series-module__zzTaiW__tabletitle",
  "ulclass": "optional-test-series-module__zzTaiW__ulclass",
  "ulliclass": "optional-test-series-module__zzTaiW__ulliclass",
  "ullispan": "optional-test-series-module__zzTaiW__ullispan",
});
